import React from 'react';
import { Card, CardContent } from './ui/card';
import { AlertTriangle, Calculator, Zap } from 'lucide-react';

const Problems = () => {
  const problems = [
    {
      icon: <AlertTriangle className="h-8 w-8 text-destructive" />,
      title: "Frustrated with task assignment and follow-ups?",
      description: "Managing daily tasks and tracking progress becomes overwhelming as your team grows.",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NjA1OTE2NjF8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      icon: <Calculator className="h-8 w-8 text-destructive" />,
      title: "Struggling to measure project effort costs?",
      description: "Calculating accurate project costs with multiple employees and varying salary brackets is complex."
    },
    {
      icon: <Zap className="h-8 w-8 text-destructive" />,
      title: "Market-ready software too complex and expensive?",
      description: "Existing project management tools are either too complicated or cost-prohibitive for growing businesses."
    }
  ];

  return (
    <section className="py-20 lg:py-32 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Common Project Management
            <span className="text-gradient-primary block">
              Challenges
            </span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Every growing business faces these critical challenges in project management and cost tracking
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <Card key={index} className="group hover-lift border-0 shadow-card bg-card/60 backdrop-blur-sm animate-fade-in" style={{ animationDelay: `${index * 0.2}s` }}>
              <CardContent className="p-8 text-center space-y-6">
                <div className="flex justify-center">
                  <div className="p-3 rounded-full bg-destructive/10 group-hover:bg-destructive/20 transition-colors duration-300">
                    {problem.icon}
                  </div>
                </div>
                
                <h3 className="text-xl font-heading font-semibold text-foreground leading-tight">
                  {problem.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed">
                  {problem.description}
                </p>
                
                {problem.image && (
                  <div className="relative mt-6 rounded-lg overflow-hidden">
                    <img
                      src={problem.image}
                      alt="Team collaboration challenges"
                      className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-card/80 via-transparent to-transparent"></div>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Solution Teaser */}
        <div className="text-center mt-16 animate-fade-in">
          <div className="inline-flex items-center space-x-2 bg-gradient-cool text-white px-6 py-3 rounded-full shadow-warm">
            <Zap className="h-5 w-5" />
            <span className="font-semibold">Save 30% effort & time daily with our solution</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;